import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchGqBlogCategoryDataGet } from '../../../api-cms-client';

const initialState = {
    loading: false,
    error: null,
    data: null,
};

export const getGqBlogCategoryFetch = createAsyncThunk(
    'getGqBlogCategoryFetch/Get',
    async (body, { rejectWithValue }) => {
        try {
            const response = await fetchGqBlogCategoryDataGet(body);
            const data = response?.data;
            return data;
        } catch (err) {
            const errObj = {
                type: 'GET_GQ_BLOG_CATEGORY_FETCH_FAILURE',
                error: err,
                message: 'Oops! something went wrong',
            };
            return rejectWithValue(err?.response?.data || errObj);
        }
    }
);

const getGqBlogCategoryFetchSlice = createSlice({
    name: 'getGqBlogCategoryFetchSlice',
    initialState,
    extraReducers: {
        [getGqBlogCategoryFetch.fulfilled]: (state, { payload }) => {
            state.data = payload?.data;
        },
        [getGqBlogCategoryFetch.rejected]: (state) => {
            state.data = null;
        },
    },
});

export const getGqBlogCategoryFetchSelector = (state) => state.getGqBlogCategoryFetch;
export const getGqBlogCategoryFetchReducer = getGqBlogCategoryFetchSlice.reducer;
